module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    class: [
      'widget',
      _vm.hasMargin && 'tab-margin',
      _vm.tabTitles.length === 2 && !_vm.isSlot && _vm.type != 'third-group' && !_vm.isFlexStart && 'tab-padding-160',
      _vm.tabTitles.length === 3 && !_vm.isSlot && _vm.type != 'third-group' && !_vm.isFlexStart && 'tab-padding-40',
      _vm.isSlot && 'flex-expand-layout',
      _vm.type == 'third-group' && 'thirdTabPanel'
    ],
    style: ({
      backgroundColor: _vm.mergeStyleOption.bgColor
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.type === 'third-group' && !_vm._isColmo) ? _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['dof-third-panel'],
    style: ({
      'background-color': _vm.mergeStyleOption.bgColor
    }),
    attrs: {
      "accessible": true,
      "aria-label": _vm.text,
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "btn-group-wrap weex-ct weex-div",
    style: (_vm._px2rem(_vm.wrapStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.tabTitles), function(text, index) {
    return _c('p', {
      key: index,
      staticClass: " weex-el weex-text",
      class: [
        'btn-text',
        index == 0 && 'leftRadius',
        index == _vm.tabTitles.length - 1 && 'rightRadius',
        !_vm.disabled && _vm.pattern === 'text' && ("dof-text-highlight-" + _vm.type)
      ],
      style: ([index < _vm.tabTitles.length - 1 ? _vm._processExclusiveStyle(_vm.verticalLineStyle, 75, 'text') : _vm._processExclusiveStyle('', 75, 'text'), _vm._processExclusiveStyle(_vm.textStyle, 75, 'text'), index == _vm.tabCheckedIndex ? _vm._processExclusiveStyle(_vm.textBtnStyle(index), 75, 'text') : _vm._processExclusiveStyle('', 75, 'text')]),
      attrs: {
        "data-index": index,
        "weex-type": "text",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.onTextClicked(index)
        }
      }
    }, [_vm._v(_vm._s(text))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.type === 'third-group' && _vm._isColmo) ? _c('dof-diamond-tab', {
    attrs: {
      "tabData": _vm.tabTitles,
      "bgColor": '#151617',
      "activeTextColor": 'rgb(230, 230, 230)',
      "touchColor": 'rgb(26, 26, 26)',
      "textFontSize": '28px',
      "active": _vm.tabCheckedIndex,
      "data-evt-tabActiveChange": ""
    },
    on: {
      "tabActiveChange": _vm.tabActiveChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'third') ? _c('scroller', {
    class: ['tab-title-list', _vm.tabTitles.length <= 5 && 'space-around-layout'],
    attrs: {
      "show-scrollbar": false,
      "scroll-direction": "horizontal"
    }
  }, _vm._l((_vm.tabTitles), function(v, index) {
    return _c('div', {
      key: index,
      ref: 'dof-tab-title-' + index,
      refInFor: true,
      staticClass: " weex-ct weex-div",
      class: ['title-item', _vm.tabTitles.length > 5 && 'padding-layout-8'],
      attrs: {
        "weex-type": "div",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.onClicked(index, _vm.tabTitles.length - 1)
        }
      }
    }, [_c('div', {
      staticClass: "tab-text-wrapper thidrd-wrapper weex-ct weex-div",
      style: ({
        backgroundColor: _vm.currentPage === index ? _vm.mergeStyleOption.activeBoxBgColor : (v.icon || v.activeIcon) && !_vm._isDiablo ? 'transparent' : _vm.mergeStyleOption.boxBgColor,
        borderColor: _vm.currentPage === index && _vm.mergeStyleOption.activeBorderColor ? _vm.mergeStyleOption.activeBorderColor : _vm.mergeStyleOption.borderColor
      }),
      attrs: {
        "weex-type": "div"
      }
    }, [(v.icon || v.activeIcon) ? _c('figure', {
      staticClass: "avatar-icon weex-el weex-image",
      attrs: {
        "src": _vm.currentPage === index ? v.activeIcon : v.icon,
        "data-img-src": _vm.currentPage === index ? v.activeIcon : v.icon,
        "weex-type": "image"
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "tab-text third-text weex-el weex-text",
      style: ({
        fontWeight: _vm.currentPage === index && _vm.mergeStyleOption.isActiveTitleBold ? 'normal' : 'normal',
        color: _vm.currentPage === index ? _vm.mergeStyleOption.activeTitleColor : _vm.mergeStyleOption.titleColor
      }),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(v.title))])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.type !== 'third' && _vm.type !== 'third-group') ? _c('scroller', {
    class: ['tab-title-list', _vm.tabTitles.length <= 5 && 'space-around-layout', _vm.isFlexStart && 'flex-start-layout'],
    attrs: {
      "show-scrollbar": false,
      "scroll-direction": "horizontal"
    }
  }, _vm._l((_vm.tabTitles), function(v, index) {
    return _c('div', {
      key: index,
      ref: 'dof-tab-title-' + index,
      refInFor: true,
      staticClass: " weex-ct weex-div",
      class: ['title-item', _vm.tabTitles.length > 5 && 'padding-layout-32', _vm.type == 'primary' && 'title-item-primary', _vm.isFlexStart && _vm.tabTitles.length - 1 !== index && 'flex-start-item'],
      attrs: {
        "weex-type": "div",
        "data-evt-click": ""
      },
      on: {
        "click": _vm.$stopOuterA,
        "weex$tap": function($event) {
          $event.stopPropagation();
          return _vm.onClicked(index, _vm.tabTitles.length - 1)
        }
      }
    }, [_c('div', {
      staticClass: " weex-ct weex-div",
      class: ['tab-text-wrapper', _vm.isSlot && 'minibar-inner'],
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      staticClass: "flexDirection weex-ct weex-div",
      class: [v.hasDotNum && 'dot-num-tip-right'],
      attrs: {
        "weex-type": "div"
      }
    }, [_c('p', {
      staticClass: " weex-el weex-text",
      class: ['tab-text', 'dot-tab-text'],
      style: ({
        fontSize: _vm._px2rem(_vm.isFlexStart && _vm.currentPage === index ? '36px' : _vm.isFlexStart && _vm.currentPage !== index ? '28px' : _vm.type === 'primary' ? '32px' : '28px', 75),
        fontWeight: _vm.currentPage === index && _vm.mergeStyleOption.isActiveTitleBold ? 'normal' : 'normal',
        color: _vm.currentPage === index ? _vm.mergeStyleOption.activeTitleColor : _vm.mergeStyleOption.titleColor
      }),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(v.title))]), _vm._v(" "), (v.hasDotTip) ? _c('div', {
      staticClass: " weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [_c('div', {
      staticClass: "dot-tip weex-ct weex-div",
      style: ({
        'background-color': v.badgeColor ? v.badgeColor : '#F56428'
      }),
      attrs: {
        "weex-type": "div"
      }
    })]) : (v.hasDotNum) ? _c('p', {
      staticClass: "dot-num-tip-text weex-el weex-text",
      style: ({
        'background-color': v.badgeColor ? v.badgeColor : '#F56428'
      }),
      attrs: {
        "weex-type": "text"
      }
    }, [_vm._v(_vm._s(_vm.dotNum(v.hasDotNum, v.badgeMax)))]) : _vm._e()])]), _vm._v(" "), (_vm.type !== 'third' && _vm.type !== 'third-group') ? _c('div', {
      staticClass: " weex-ct weex-div",
      class: [
        _vm.type == 'primary' ? 'border-bottom-line' : 'border-bottom-line-secondary',
        v.hasDotTip && 'dot-bottom-border',
        v.hasDotNum && 'dotNum-bottom-borderWidth'
      ],
      style: ({
        backgroundColor: _vm.currentPage === index ? _vm.mergeStyleOption.activeBottomColor : 'transparent'
      }),
      attrs: {
        "weex-type": "div"
      }
    }) : _vm._e()])
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-401fdb82", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-401fdb82","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-tab-page/index.vue
// module id = 598
// module chunks = 0 1